export enum MenuPlacement {
	TOP = 'top',
	AUTO = 'auto',
	BOTTOM = 'bottom',
}
